import { useEffect } from 'react';

import EmptyState from '@ergeon/core-components/exports/EmptyState.ts';
import { VideoCameraIcon } from '@ergeon/icons/hero/outline';

// Strictly the dev server: staging is a customer-facing ground and must
// redirect exactly like production.
function isDevServer() {
  return import.meta.env.MODE === 'development';
}

function Main() {
  useEffect(function disallowIndexEnter() {
    // The bare domain has nothing to show a visitor, so production sends them
    // to the main site. Locally that redirect fires the moment the dev server
    // opens, before you can type a /call/<hash> path — so dev keeps the page.
    if (!isDevServer()) {
      location.href = 'https://ergeon.com';
    }
  }, []);

  if (!isDevServer()) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <EmptyState
        description="Open /call/<meeting-hash> to enter a call. Production redirects this page to ergeon.com."
        icon={<VideoCameraIcon />}
        title="onsite dev server"
      />
    </div>
  );
}

export default Main;
